import type { DragInput } from "../features/dnd/dragKind";
import type { GridController } from "../focus/gridController";
import { readTableMotion } from "./tableMotion";

/** The landed row flashes once the preview has settled onto it. */
export const flashDroppedRow = ({
    controller,
    rowId,
    input,
}: {
    controller: GridController;
    rowId: string;
    input: DragInput;
}) =>
    requestAnimationFrame(() => {
        const element = controller.body?.querySelector<HTMLElement>(
            `:scope > [data-row-id="${CSS.escape(rowId)}"]`,
        );
        if (!element) {
            return;
        }
        const motion = readTableMotion(element);
        const color = getComputedStyle(element)
            .getPropertyValue("--dg-drop-bg")
            .trim();
        if (motion.isOff || !color) {
            return;
        }
        element.animate(
            [{ "--dg-row-bg": color }, { "--dg-row-bg": color, offset: 0.4 }],
            {
                duration: motion.slowMs,
                delay:
                    input === "keyboard" || motion.isReduced
                        ? 0
                        : motion.mediumMs,
                easing: motion.easeOut,
            },
        );
    });
